import { render, staticRenderFns } from "./RemessaBancariaFinanceiro.vue?vue&type=template&id=3ad07fbf&scoped=true&"
import script from "./remessaBancariaFinanceiro.js?vue&type=script&lang=js&"
export * from "./remessaBancariaFinanceiro.js?vue&type=script&lang=js&"
import style0 from "./RemessaBancariaFinanceiro.vue?vue&type=style&index=0&id=3ad07fbf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad07fbf",
  null
  
)

export default component.exports